import { render, staticRenderFns } from "./ManageFreeClassesComponent.vue?vue&type=template&id=08995772&scoped=true&"
import script from "./ManageFreeClassesComponent.vue?vue&type=script&lang=js&"
export * from "./ManageFreeClassesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ManageFreeClassesComponent.vue?vue&type=style&index=0&id=08995772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08995772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08995772')) {
      api.createRecord('08995772', component.options)
    } else {
      api.reload('08995772', component.options)
    }
    module.hot.accept("./ManageFreeClassesComponent.vue?vue&type=template&id=08995772&scoped=true&", function () {
      api.rerender('08995772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/ManageFreeClassesComponent.vue"
export default component.exports